'use client'

import { useContext, useEffect, useRef, useState } from "react";
import { useRouter } from 'next/navigation';

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  ClickAwayListener,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  OutlinedInput,
  Paper,
  Popper,
  Stack,
  Switch,
  Typography,
} from "@mui/material";

// third-party
import PerfectScrollbar from "react-perfect-scrollbar";

// project imports
import MainCard from "@/app/ui-component/cards/MainCard";
import Transitions from "@/app/ui-component/extended/Transitions";

// assets
import useConfig from "@/app/hooks/useConfig";
import { useIntl } from "react-intl";
import RoleData from "@/app/services/admin/RoleData";

import {
  deconnection,
  logUtilisateurs,
} from "@/app/global-functions/UserEnLigneLogOut";

import { getBaseURL } from "@/app/global-functions/baseURLUtils-administrators";

import { useSelector } from "@/app/store";
import { dispatch } from "@/app/store";
import { setParamMemoire, setUserImagePath } from "@/app/store/slices/diversParametersRedux";
import { getUniversityName } from "@/app/global-functions/getUniversityName";
import { handleRedirection } from "@//app/global-functions/handleRedirection";
import { IconLogout, IconSettings, IconUser } from "@tabler/icons-react";
import { deconnectionEtudiantApi } from "@/app/global-functions/UserEnLigneLogOutStudentApi";
// import socketIOClient from 'socket.io-client';

import Image from 'next/image';
import UserService from "@/app/services/admin/User.service";
import { logouAllSystem } from "@/app/global-functions/logout/logouAllSystem";
import CloseIcon from "@mui/icons-material/Close";

// ==============================|| PROFILE MENU ||============================== //

const ProfileSection = () => {
  const theme = useTheme();
  const { borderRadius } = useConfig();
  const navigate = useRouter();

  const [selectedIndex, setSelectedIndex] = useState(-1);
  // const { logout, user } = useAuth();
  const [open, setOpen] = useState(false);
  const { paramMemoire } = useSelector((state) => state.diversParametersRedux);

  const [userImage, setUserImage] = useState("");
  const intl = useIntl();
  const [userName, setUserName] = useState("");
  const [role, setRole] = useState("");

  const [url, setUrl] = useState(getBaseURL()); // backend URL
  const [userID, setUserID] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [typeUtilisateur, setTypeUtilisateur] = useState("");
  const [abreviaturaUniversidade, setabreviaturaUniversidade] = useState("");

  const [userIDStudent, setuserIDStudent] = useState("");

  const fallbackImage = "/images/default-user.png"; // Default fallback image

  const [openImage, setOpenImage] = useState(false);

// const ENDPOINT =  baseURL.replace(/\/api$/, '');   //  "http://localhost:6600";
// const socket = socketIOClient(ENDPOINT);

  useEffect(() => {

    try {
      fetchUniversityName();


        paramMemoire.map((item) => {
        if(Number(item.typeUtilisateur) > 10) {
          const fotoFileName = item.photofilename?item.photofilename:""
       //   console.log("imageshowing11111############# ", item.photofilename )

        /*   setUserImage(
            `${url}/users/images?tipoDisplay=${encodeURIComponent(fotoFileName)}&typeUtilisateur=${item.typeUtilisateur}`
          );
 */
          setUserName(item.firstName + " " + item.lastName);
          setRole(Number(20));  
          setUserID(item.id);
          setFirstname(item.firstName);
          setlastname(item.lastnNme);
          setTypeUtilisateur(item.typeUtilisateur);
  

         /*  dispatch(
            setUserImagePath(
              `${url}/users/images?tipoDisplay=${encodeURIComponent(fotoFileName)}&typeUtilisateur=${item.typeUtilisateur}`
            )
          ); */
        }

        if(Number(item.typeUtilisateur) ===3) {
         
          getImageAsBase64();

         /*  setUserImage(
            item.photofilename !== ""
              ? `${url}/studentMatriculas/images?tipoDisplay=${encodeURIComponent(item.photofilename)}`
              : `${url}/studentMatriculas/images?tipoDisplay=semfoto.png`
          );
 */
          setUserName(item.firstname + " " + item.lastname);
          setRole(Number(20));  
          setUserID(item.id);
          setuserIDStudent(item?.userID);
          setFirstname(item.firstname);
          setlastname(item.lastname);
          setTypeUtilisateur(item.typeUtilisateur);
  
         /*  dispatch(
            setUserImagePath(
              item.photofilename !== ""
                ? `${url}/studentMatriculas/images?tipoDisplay=${encodeURIComponent(item.photofilename)}`
                : `${url}/studentMatriculas/images?tipoDisplay=semfoto.png`
            )
           
            ); */
        }

        if(Number(item.typeUtilisateur) ===2) {
         
          getImageAsBase64();


         /*  setUserImage(
            item.photofilename !== ""
              ? `${url}/professeur/images?tipoDisplay=${encodeURIComponent(item.photofilename)}`
              : `${url}/professeur/images?tipoDisplay=semfoto.png`
          ); */

          setUserName(item.firstname + " " + item.lastname);
          setRole(Number(20));  
          setUserID(item.id);
          setFirstname(item.firstname);
          setlastname(item.lastname);
          setTypeUtilisateur(item.typeUtilisateur);
  
           /*
          dispatch(
            setUserImagePath(
              item.photofilename !== ""
                ? `${url}/professeur/images?tipoDisplay=${encodeURIComponent(item.photofilename)}`
                : `${url}/professeur/images?tipoDisplay=semfoto.png`
            ) 
          
            );
            */
        }
        
        else {
          const fotoFileName = item.photofilename?item.photofilename:""

          getImageAsBase64();


         /*  setUserImage(
            `${url}/users/images?tipoDisplay=${encodeURIComponent(fotoFileName)}&typeUtilisateur=${item.typeUtilisateur}`
          ); */

          setUserName(item.firstname + " " + item.lastname);
          setRole(Number(item.typeUtilisateur)<3?item.role:10);  
          setUserID(item.id);
          setFirstname(item.firstname);
          setlastname(item.lastname);
          setTypeUtilisateur(item.typeUtilisateur);
  
       /*  dispatch(
          setUserImagePath(
            `${url}/users/images?tipoDisplay=${encodeURIComponent(fotoFileName)}&typeUtilisateur=${item.typeUtilisateur}`
          )
        );   */
                }
      

      });
    } catch (error) {}

    return () => {};
  }, [userImage, paramMemoire, abreviaturaUniversidade ]);

  const fetchUniversityName = async () => {
    const university = await getUniversityName();
     // console.log("university######## ", university);

    setabreviaturaUniversidade(university.abreviatura);
  };

  const anchorRef = useRef(null);
  
  const handleLogout = async () => {

    try {
      // socket.emit('disconnectUser', { socketId: socket.id, userID: userID, userName });
      
      const updatedParamMemoire = paramMemoire.map((item) => ({
        ...item,
        isLoggedIn2: false,
    }));

    await dispatch(setParamMemoire(updatedParamMemoire));

      if(Number(typeUtilisateur) >=3) {

        const disconnect = {
          enligne : 0,
          disconectBeforeConnect : 0,
          tipo : "userUpdateEnLigneDisocnnectStudent",
          userID:  userIDStudent,
        }

       await  UserService.updateStudent(userID, disconnect).
        then(async(response) => {

      await   deconnectionEtudiantApi(userID, 0, 0); // deconnexion de la salle de deliberation et du ssystem en ligne
      
      await logouAllSystem();

      handleRedirection(abreviaturaUniversidade, navigate);
 
        })
      
      }else {

        const disconnect = {
          enligne : 0,
          disconectBeforeConnect : 0,
          tipo : "updateEnLigneNew",
          userID,
        }
       await  UserService.update(userID, disconnect).
        then(async(response) => {

       //    console.log("UserService99999####### ", response.data)


        //   console.log("abreviaturaUniversidade777777777777########### ", abreviaturaUniversidade);
     //     console.log("navigat777777777777e########### ", firstname);
       //    console.log("navigat777777777777e########### ", lastname)

   
          await  deconnection(userID, 0, 0, firstname, lastname); // deconnexion de la salle de deliberation et du ssystem en ligne

          await logouAllSystem();

          await   handleRedirection(abreviaturaUniversidade, navigate);
    
        })
      
      }

    } catch (err) {
      console.error(err);
    }
  };

  const redirectToExternalURL = (externalURL) => {
    window.location.reload(true);
    window.location.href = externalURL;

  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenImage(false);
    setOpen(false);
  };
  const handleListItemClick = (event, index, route = "") => {
    setSelectedIndex(index);
    handleClose(event);

    if (route && route !== "") {
      navigate.push(route);
    }
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open, abreviaturaUniversidade]);

  function getRole(idRole) {
    const resultRole = RoleData().find(
      ({ id }) => Number(id) === Number(idRole)
    );
    return resultRole.title;
  }

  async function getImageAsBase64() {
    // Correctly retrieve the value using the exact key
    const storedImageLocally = localStorage.getItem('storedIUsermage'); // Notice the exact case
   //  console.log("Stored Image Locally3333333333:", storedImageLocally);
  
   // if (storedImageLocally && storedImageLocally.startsWith('data:image/')) {
   //    console.log("Valid Base64 Image Found");
      setUserImage(storedImageLocally);

  //  } 
  //  else {
   //   console.error('Stored image is not in valid base64 format or is missing');
  //  }
  }

  const handleImageClick = () => {
    setOpenImage(true);
  };


  return (
    <>
      <Chip
  sx={{
    height: "48px",
    alignItems: "center",
    borderRadius: "27px",
    transition: "all .2s ease-in-out",
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.dark.main
        : theme.palette.primary.light,
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.dark.main
        : theme.palette.primary.light,
    '&[aria-controls="menu-list-grow"], &:hover': {
      borderColor: theme.palette.primary.main,
      background: `${theme.palette.primary.main}!important`,
      color: theme.palette.primary.light,
      "& svg": {
        stroke: theme.palette.primary.light,
      },
    },
    "& .MuiChip-label": {
      lineHeight: 0,
    },
  }}
  icon={
    <Box
      sx={{
        position: "relative",
        width: 32, // Adjust the size as needed
        height: 32, // Adjust the size as needed
        borderRadius: "50%",
        overflow: "hidden",
        cursor: "pointer",
        margin: "8px 0 8px 8px !important",
      }}
      onClick={handleImageClick} // Open popup on click

      ref={anchorRef}
      aria-controls={open ? "menu-list-grow" : undefined}
      aria-haspopup="true"
    >
      <Image
        src={userImage || fallbackImage}
        layout="fill"
        optimized
        style={{
          borderRadius: "50%",
        }}
        priority // Optional: Preload the image for better performance
        alt="User Profile"
        onClick={(e) => {
          e.stopPropagation(); // Prevent event bubbling
          handleImageClick();
        }} 
      />
    </Box>
  }
  label={
    <IconSettings
      stroke={1.5}
      size="1.5rem"
      color={theme.palette.primary.main}
    />
  }
  variant="outlined"
  ref={anchorRef}
  aria-controls={open ? "menu-list-grow" : undefined}
  aria-haspopup="true"
  onClick={handleToggle}
  color="primary"
/>

      <Popper
        placement="bottom"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 14],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Transitions in={open} {...TransitionProps}>
              <Paper>
                {open && (
                  <MainCard
                    border={false}
                    elevation={16}
                    content={false}
                    boxShadow
                    shadow={theme.shadows[16]}
                  >
                    <Box sx={{ p: 2, pb: 0 }}>
                      <Stack>
                        <Stack
                          direction="row"
                          spacing={0.5}
                          alignItems="center"
                        >
                          <Typography variant="h4">
                            {" "}
                            {intl.formatMessage({ id: "bom_dia" })},
                          </Typography>
                          <Typography
                            component="span"
                            variant="h4"
                            sx={{ fontWeight: 400 }}
                          >
                            {/* {user?.name} */}
                            {userName}
                          </Typography>
                        </Stack>
                        <Typography variant="subtitle2">
                          {getRole(role)}
                        </Typography>
                      </Stack>
                      
                    </Box>
                    <PerfectScrollbar
                      style={{
                        height: "100%",
                        maxHeight: "calc(100vh - 250px)",
                        overflowX: "hidden",
                      }}
                    >
                      <Box sx={{ p: 2, pt: 0 }}>
                       
                        <Divider />
                        <List
                          component="nav"
                          sx={{
                            width: "100%",
                            maxWidth: 350,
                            minWidth: 300,
                            backgroundColor: theme.palette.background.paper,
                            borderRadius: "10px",
                            [theme.breakpoints.down("md")]: {
                              minWidth: "100%",
                            },
                            "& .MuiListItemButton-root": {
                              mt: 0.5,
                            },
                          }}
                        >
                          <ListItemButton
                            sx={{ borderRadius: `${borderRadius}px` }}
                            selected={selectedIndex === 0}
                           /*  onClick={(event) =>
                              handleListItemClick(
                                event,
                                0,
                                "/user/account-profile/profile1"
                              )
                            } */
                          >
                            <ListItemIcon>
                              <IconSettings stroke={1.5} size="1.3rem" />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <Typography variant="body2">
                                  {intl.formatMessage({
                                    id: "configuracao_da_conta",
                                  })}
                                </Typography>
                              }
                            />
                          </ListItemButton>
                          <ListItemButton
                            sx={{ borderRadius: `${borderRadius}px` }}
                            selected={selectedIndex === 1}
                            onClick={(event) =>
                              handleListItemClick(event, 1, "#")
                            }
                          >
                            <ListItemIcon>
                              <IconUser stroke={1.5} size="1.3rem" />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <Grid
                                  container
                                  spacing={1}
                                  justifyContent="space-between"
                                >
                                  <Grid item>
                                    <Typography variant="body2">
                                    {intl.formatMessage({ id: "notifications" })}
                                    </Typography>
                                  </Grid>
                                  <Grid item>
                                    <Chip
                                      label="02"
                                      size="small"
                                      sx={{
                                        bgcolor:
                                          theme.palette.mode === "dark"
                                            ? theme.palette.dark.dark
                                            : theme.palette.warning.dark,
                                        color: theme.palette.background.default,
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              }
                            />
                          </ListItemButton>
                          <ListItemButton
                            sx={{ borderRadius: `${borderRadius}px` }}
                            selected={selectedIndex === 4}
                            onClick={handleLogout}
                          >
                            <ListItemIcon>
                              <IconLogout stroke={1.5} size="1.3rem" />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <Typography variant="body2">{intl.formatMessage({ id: "logout" })}</Typography>
                              }
                            />
                          </ListItemButton>
                        </List>
                      </Box>
                    </PerfectScrollbar>
                  </MainCard>
                )}
              </Paper>
            </Transitions>
          </ClickAwayListener>
        )}
      </Popper>
      
      
{/* Dialog for Enlarged Image */}
<Dialog open={openImage} onClose={handleClose} maxWidth="md">
  <DialogTitle>
    <IconButton
      aria-label="close"
      onClick={handleClose}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent>
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Image
        src={userImage || fallbackImage}
        width={380} // Adjust size as needed
        height={300}
        unoptimized
        style={{
          borderRadius: "10px",
          maxWidth: "100%",
          maxHeight: "100%",
        }}
        alt="Enlarged Profile"
      />
    </Box>
  </DialogContent>
</Dialog>
    </>
  );
};

export default ProfileSection;
